import { u as V, i as F, T as u, E as k } from "./lit-element-8JrrHldg.js";
import { b as _, _ as y } from "./chunk.UYAO2JRR-CUGf3xdB.js";
import { e as x, i as I, t as a } from "./directive-B76A7YXI.js";
import { f as w, m as O } from "./directive-helpers-ClFP2-bH.js";
var R = (t = "value") => (r, e) => {
  const o = r.constructor, i = o.prototype.attributeChangedCallback;
  o.prototype.attributeChangedCallback = function(s, l, m) {
    var b;
    const c = o.getPropertyOptions(t), A = typeof c.attribute == "string" ? c.attribute : t;
    if (s === A) {
      const d = c.converter || V, g = (typeof d == "function" ? d : (b = d == null ? void 0 : d.fromAttribute) != null ? b : V.fromAttribute)(m, c.type);
      this[t] !== g && (this[e] = g);
    }
    i.call(this, s, l, m);
  };
}, U = F`
  .form-control .form-control__label {
    display: none;
  }

  .form-control .form-control__help-text {
    display: none;
  }

  /* Label */
  .form-control--has-label .form-control__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    margin-bottom: var(--sl-spacing-3x-small);
  }

  .form-control--has-label.form-control--small .form-control__label {
    font-size: var(--sl-input-label-font-size-small);
  }

  .form-control--has-label.form-control--medium .form-control__label {
    font-size: var(--sl-input-label-font-size-medium);
  }

  .form-control--has-label.form-control--large .form-control__label {
    font-size: var(--sl-input-label-font-size-large);
  }

  :host([required]) .form-control--has-label .form-control__label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
    color: var(--sl-input-required-content-color);
  }

  /* Help text */
  .form-control--has-help-text .form-control__help-text {
    display: block;
    color: var(--sl-input-help-text-color);
    margin-top: var(--sl-spacing-3x-small);
  }

  .form-control--has-help-text.form-control--small .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-small);
  }

  .form-control--has-help-text.form-control--medium .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-medium);
  }

  .form-control--has-help-text.form-control--large .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-large);
  }

  .form-control--has-help-text.form-control--radio-group .form-control__help-text {
    margin-top: var(--sl-spacing-2x-small);
  }
`, n = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakSet(), p = /* @__PURE__ */ new WeakMap(), q = class {
  constructor(t, r) {
    this.handleFormData = (e) => {
      const o = this.options.disabled(this.host), i = this.options.name(this.host), s = this.options.value(this.host), l = this.host.tagName.toLowerCase() === "sl-button";
      this.host.isConnected && !o && !l && typeof i == "string" && i.length > 0 && typeof s < "u" && (Array.isArray(s) ? s.forEach((m) => {
        e.formData.append(i, m.toString());
      }) : e.formData.append(i, s.toString()));
    }, this.handleFormSubmit = (e) => {
      var o;
      const i = this.options.disabled(this.host), s = this.options.reportValidity;
      this.form && !this.form.noValidate && ((o = n.get(this.form)) == null || o.forEach((l) => {
        this.setUserInteracted(l, !0);
      })), this.form && !this.form.noValidate && !i && !s(this.host) && (e.preventDefault(), e.stopImmediatePropagation());
    }, this.handleFormReset = () => {
      this.options.setValue(this.host, this.options.defaultValue(this.host)), this.setUserInteracted(this.host, !1), p.set(this.host, []);
    }, this.handleInteraction = (e) => {
      const o = p.get(this.host);
      o.includes(e.type) || o.push(e.type), o.length === this.options.assumeInteractionOn.length && this.setUserInteracted(this.host, !0);
    }, this.checkFormValidity = () => {
      if (this.form && !this.form.noValidate) {
        const e = this.form.querySelectorAll("*");
        for (const o of e)
          if (typeof o.checkValidity == "function" && !o.checkValidity())
            return !1;
      }
      return !0;
    }, this.reportFormValidity = () => {
      if (this.form && !this.form.noValidate) {
        const e = this.form.querySelectorAll("*");
        for (const o of e)
          if (typeof o.reportValidity == "function" && !o.reportValidity())
            return !1;
      }
      return !0;
    }, (this.host = t).addController(this), this.options = y({
      form: (e) => {
        const o = e.form;
        if (o) {
          const s = e.getRootNode().querySelector(`#${o}`);
          if (s)
            return s;
        }
        return e.closest("form");
      },
      name: (e) => e.name,
      value: (e) => e.value,
      defaultValue: (e) => e.defaultValue,
      disabled: (e) => {
        var o;
        return (o = e.disabled) != null ? o : !1;
      },
      reportValidity: (e) => typeof e.reportValidity == "function" ? e.reportValidity() : !0,
      checkValidity: (e) => typeof e.checkValidity == "function" ? e.checkValidity() : !0,
      setValue: (e, o) => e.value = o,
      assumeInteractionOn: ["sl-input"]
    }, r);
  }
  hostConnected() {
    const t = this.options.form(this.host);
    t && this.attachForm(t), p.set(this.host, []), this.options.assumeInteractionOn.forEach((r) => {
      this.host.addEventListener(r, this.handleInteraction);
    });
  }
  hostDisconnected() {
    this.detachForm(), p.delete(this.host), this.options.assumeInteractionOn.forEach((t) => {
      this.host.removeEventListener(t, this.handleInteraction);
    });
  }
  hostUpdated() {
    const t = this.options.form(this.host);
    t || this.detachForm(), t && this.form !== t && (this.detachForm(), this.attachForm(t)), this.host.hasUpdated && this.setValidity(this.host.validity.valid);
  }
  attachForm(t) {
    t ? (this.form = t, n.has(this.form) ? n.get(this.form).add(this.host) : n.set(this.form, /* @__PURE__ */ new Set([this.host])), this.form.addEventListener("formdata", this.handleFormData), this.form.addEventListener("submit", this.handleFormSubmit), this.form.addEventListener("reset", this.handleFormReset), h.has(this.form) || (h.set(this.form, this.form.reportValidity), this.form.reportValidity = () => this.reportFormValidity()), f.has(this.form) || (f.set(this.form, this.form.checkValidity), this.form.checkValidity = () => this.checkFormValidity())) : this.form = void 0;
  }
  detachForm() {
    if (!this.form)
      return;
    const t = n.get(this.form);
    t && (t.delete(this.host), t.size <= 0 && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit), this.form.removeEventListener("reset", this.handleFormReset), h.has(this.form) && (this.form.reportValidity = h.get(this.form), h.delete(this.form)), f.has(this.form) && (this.form.checkValidity = f.get(this.form), f.delete(this.form)), this.form = void 0));
  }
  setUserInteracted(t, r) {
    r ? v.add(t) : v.delete(t), t.requestUpdate();
  }
  doAction(t, r) {
    if (this.form) {
      const e = document.createElement("button");
      e.type = t, e.style.position = "absolute", e.style.width = "0", e.style.height = "0", e.style.clipPath = "inset(50%)", e.style.overflow = "hidden", e.style.whiteSpace = "nowrap", r && (e.name = r.name, e.value = r.value, ["formaction", "formenctype", "formmethod", "formnovalidate", "formtarget"].forEach((o) => {
        r.hasAttribute(o) && e.setAttribute(o, r.getAttribute(o));
      })), this.form.append(e), e.click(), e.remove();
    }
  }
  /** Returns the associated `<form>` element, if one exists. */
  getForm() {
    var t;
    return (t = this.form) != null ? t : null;
  }
  /** Resets the form, restoring all the control to their default value */
  reset(t) {
    this.doAction("reset", t);
  }
  /** Submits the form, triggering validation and form data injection. */
  submit(t) {
    this.doAction("submit", t);
  }
  /**
   * Synchronously sets the form control's validity. Call this when you know the future validity but need to update
   * the host element immediately, i.e. before Lit updates the component in the next update.
   */
  setValidity(t) {
    const r = this.host, e = !!v.has(r), o = !!r.required;
    r.toggleAttribute("data-required", o), r.toggleAttribute("data-optional", !o), r.toggleAttribute("data-invalid", !t), r.toggleAttribute("data-valid", t), r.toggleAttribute("data-user-invalid", !t && e), r.toggleAttribute("data-user-valid", t && e);
  }
  /**
   * Updates the form control's validity based on the current value of `host.validity.valid`. Call this when anything
   * that affects constraint validation changes so the component receives the correct validity states.
   */
  updateValidity() {
    const t = this.host;
    this.setValidity(t.validity.valid);
  }
  /**
   * Dispatches a non-bubbling, cancelable custom event of type `sl-invalid`.
   * If the `sl-invalid` event will be cancelled then the original `invalid`
   * event (which may have been passed as argument) will also be cancelled.
   * If no original `invalid` event has been passed then the `sl-invalid`
   * event will be cancelled before being dispatched.
   */
  emitInvalidEvent(t) {
    const r = new CustomEvent("sl-invalid", {
      bubbles: !1,
      composed: !1,
      cancelable: !0,
      detail: {}
    });
    t || r.preventDefault(), this.host.dispatchEvent(r) || t == null || t.preventDefault();
  }
}, E = Object.freeze({
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: !0,
  valueMissing: !1
});
Object.freeze(_(y({}, E), {
  valid: !1,
  valueMissing: !0
}));
Object.freeze(_(y({}, E), {
  valid: !1,
  customError: !0
}));
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const B = x(class extends I {
  constructor(t) {
    if (super(t), t.type !== a.PROPERTY && t.type !== a.ATTRIBUTE && t.type !== a.BOOLEAN_ATTRIBUTE)
      throw Error("The `live` directive is not allowed on child or event bindings");
    if (!w(t))
      throw Error("`live` bindings can only contain a single expression");
  }
  render(t) {
    return t;
  }
  update(t, [r]) {
    if (r === u || r === k)
      return r;
    const e = t.element, o = t.name;
    if (t.type === a.PROPERTY) {
      if (r === e[o])
        return u;
    } else if (t.type === a.BOOLEAN_ATTRIBUTE) {
      if (!!r === e.hasAttribute(o))
        return u;
    } else if (t.type === a.ATTRIBUTE && e.getAttribute(o) === r + "")
      return u;
    return O(t), r;
  }
});
export {
  q as F,
  R as d,
  U as f,
  B as l,
  E as v
};
